// extracted by mini-css-extract-plugin
export var scrollArea = "_oo-0";